<template>
  <div class="main-pages">
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <div class="w-100 d-flex flex-column justify-content-between align-items-center"
      style="padding: 24px; margin-top: 82px">
      <Breadcrumb :items="breadcrumbItems" />
      <div id="divTable" style="margin-top: 32px">
        <section class="d-flex justify-content-between align-items-center w-100 flex-wrap">
          <div class="d-flex justify-content-between w-100">
            <div class="w-50 text-secondary fs-5">Lojas Cadastradas</div>
            <div class="d-flex align-items-center" style="gap: 8px">
              <b-button variant="primary" @click.prevent="logInWithFacebook">Atualizar Token</b-button>
              <!-- NOVO BOTÃO -->
              <button class="btnPrimaryWhite" @click.prevent="showModalVincular">
                Alterar Regional
              </button>
              <button class="btnPrimaryWhite" @click.prevent="showModalFacebook">
                Novo Instagram
              </button>
              <div class="input-container">
                <InputSearch @onUpdate="(value) => getStoreByName(value)" />
              </div>
            </div>
          </div>

          <div class="table-responsive w-100">
            <table class="table align-middle">
              <thead class="thead">
                <tr style="height: 50px">
                  <th>Loja</th>
                  <th>Status</th>
                  <th class="text-center">Usuário do Facebook</th>
                  <th class="text-center">Criado em</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in stores" :key="item.instaId">
                  <td>{{ item.instaPageName }}</td>
                  <td :class="[
                    item.pageTokenStatus === 'True' ? '' : 'text-danger',
                  ]">
                    {{ item.pageTokenStatus === "True" ? "Válido" : "Vencido" }}
                  </td>
                  <td class="text-center">{{ item.username || "-" }}</td>
                  <td class="text-center">
                    {{
                      item.createdAt
                        ? currentDateTime(item.createdAt)
                        : "00/00/0000"
                    }}
                  </td>
                  <td>
                    <div class="w-100 d-flex justify-content-end" v-if="item.pageTokenStatus === 'False'"></div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :count="totalStores" :offset="offset" @firstPage="pagination('clickFirstPage', false)"
              @previousPage="pagination('clickPreviousPage', false)" @nextPage="pagination('clickNextPage', false)"
              @lastPage="pagination('clickLastPage', false)" />
          </div>
        </section>
      </div>
    </div>

    <!-- Modal: Lojas Atualizadas -->
    <Modal :showModal="modal">
      <div class="modal-update">
        <div class="fs-5">Lojas Atualizadas!</div>
        <div class="list-store">
          <p v-for="(store, index) in upStores" :key="index">{{ store }}</p>
        </div>
        <b-button class="w-75" variant="primary" @click="reloadPage">Continuar</b-button>
      </div>
    </Modal>

    <!-- Modal: Vincular Lojas -->
    <Modal :showModal="modalVincular" class="modal-vincular-wrapper">
      <div class="modal-vincular">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <span class="fs-5">Alterar Regional</span>
          <button class="btn-close-modal" @click="closeModalVincular">✕</button>
        </div>

        <!-- Lista de lojas -->
        <div class="d-flex justify-content-end mb-1">
          <button class="btn-select-all" @click="toggleSelecionarTodos">
            {{ todasSelecionadas ? "Desmarcar todos" : "Selecionar todos" }}
          </button>
        </div>
        <div class="list-store-vincular" ref="listStoreVincular" @scroll="handleModalScroll">
          <div v-for="loja in storesModal" :key="loja.instaId" class="loja-item"
            :class="{ 'loja-item--selected': lojasSelecionadas.includes(loja.instaPageName) }"
            @click="toggleLoja(loja.instaPageName)">
            <input type="checkbox" :checked="lojasSelecionadas.includes(loja.instaPageName)"
              @click.stop="toggleLoja(loja.instaPageName)" />
            <span>{{ loja.instaPageName }}</span>
          </div>

            <!-- Loading scroll -->
            <div v-if="isLoadingModal" class="scroll-loading">
              <div class="spinner-border spinner-border-sm text-primary" role="status">
               
              </div>
             
            </div>

            <!-- Fim da lista -->
            <div v-if="!hasMoreModal && storesModal.length > 0" class="scroll-end">
              Todas as lojas carregadas
            </div>
        </div>



        <!-- Dropdown Regionais -->
        <div class="mt-3">
          <label class="form-label text-secondary">Regionais</label>
          <select class="form-select" v-model="regionalSelecionada">
            <option value="" disabled>Selecione uma regional</option>
         <option
          v-for="regional in regionais"
          :key="regional.id"
          :value="regional.regionalName"
        >
          {{ regional.regionalName }}
        </option>
          </select>
        </div>

        <div class="d-flex justify-content-end mt-4" style="gap: 8px">
          <button class="btnPrimaryWhite" @click="closeModalVincular">
            Cancelar
          </button>
          <b-button variant="primary" :disabled="isVinculando" @click="vincularLojas">
            {{ isVinculando ? "Vinculando..." : "Vincular" }}
          </b-button>
        </div>
      </div>
    </Modal>

    <FacebookLogin ref="modalFacebook" @showIsLoading="showIsLoading" />
  </div>
</template>

<script>
import { ref } from "vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import InputSearch from "@/components/InputSearch.vue";
import Pagination from "@/components/Pagination.vue";
import Loading from "vue-loading-overlay";
import FacebookLogin from "../components/FacebookLogin.vue";
import moment from "moment/moment";
import Modal from "@/components/ui/modal/modal.vue";

import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  components: {
    Breadcrumb,
    InputSearch,
    Loading,
    Pagination,
    FacebookLogin,
    Modal,
  },
  data() {
    return {
      offsetModal: 0,
      isLoadingModal: false,
      hasMoreModal: true,
      stores: [],
      storesModal: [],
      totalStores: 0,
      totalStoresModal: 0,
      offset: 0,
      nameToSearch: "",
      isLoading: false,
      modal: ref(false),
      upStores: [],

      // Modal Vincular
      modalVincular: ref(false),
      isVinculando: false,
      lojasSelecionadas: [],
      regionalSelecionada: "",

      // Mock — substituir por chamada de endpoint quando disponível
      lojasMock: [
        { id: 1, name: "Loja Centro" },
        { id: 2, name: "Loja Norte" },
        { id: 3, name: "Loja Sul" },
        { id: 4, name: "Loja Leste" },
        { id: 5, name: "Loja Oeste" },
      ],
      regionais: [
      
      ],

      facebookScopes:
        "email, manage_fundraisers, user_messenger_contact, threads_business_basic, pages_show_list, read_page_mailboxes, business_management, pages_messaging_phone_number, pages_messaging_subscriptions, instagram_basic, instagram_manage_comments, instagram_manage_insights, instagram_content_publish, pages_read_engagement, pages_manage_metadata, pages_read_user_content, pages_manage_ads, pages_manage_posts, pages_manage_engagement, instagram_branded_content_brand, instagram_branded_content_creator, instagram_branded_content_ads_brand, instagram_manage_events, instagram_manage_upcoming_events, pages_utility_messaging, paid_marketing_messages, instagram_creator_marketplace_discovery, facebook_creator_marketplace_discovery, public_profile, ads_management, ads_read, attribution_read, manage_app_solution, page_events, pages_manage_instant_articles, pages_manage_cta, pages_messaging, catalog_management, whatsapp_business_manage_events, read_insights, publish_video, leads_retrieval, instagram_manage_messages, commerce_account_manage_orders, commerce_account_read_orders, commerce_account_read_reports, commerce_account_read_settings, instagram_shopping_tag_products",
    };
  },
  async created() {
    this.isLoading = true;

    await this.getInstagramRelationship({
      action: "clickFirstPage",
      offset: 0,
      name: this.nameToSearch,
      limit: 5,
    })
      .then((response) => {
        this.totalStores = response.data.count;
        this.stores = response.data.data;
        this.totalStoresModal = response.data.count;
        this.storesModal = response.data.data;

        this.isLoading = false;
      })
      .catch((err) => console.log(err));


        await this.getStoresByRegional()
    .then((response) => {
      this.regionais = response.data;
    })
    .catch((err) => console.log(err));
  },

  computed: {
    ...mapGetters(["getOffset"]),
    breadcrumbItems() {
      return [
        { label: "Dashboard", route: { name: "Dashboard" } },
        { label: "Lojas", active: true },
      ];
    },
   todasSelecionadas() {
      return (
        this.lojasSelecionadas.length === this.storesModal.length &&
        this.storesModal.length > 0
      );
    },

    
  },

  methods: {
    ...mapActions([
      "getInstagramRelationship",
      "carregarPorFacebookUser",
      "atualizarToken",
      "vincularLojasRegional",
      "getStoresByRegional" // endpoint a ser implementado no store
    ]),
    ...mapMutations(["SET_OFFSET"]),

    reloadPage() {
      window.location.reload();
    },

    // --- Modal Vincular ---
    showModalVincular() {
      this.lojasSelecionadas = [];
      this.regionalSelecionada = "";
      this.offsetModal = 0;
      this.hasMoreModal = true;
      this.storesModal = [...this.stores];
      this.modalVincular = true;
    },
    closeModalVincular() {
      this.modalVincular = false;
    },
 
    toggleSelecionarTodos() {
      if (this.todasSelecionadas) {
        this.lojasSelecionadas = [];
      } else {
        this.lojasSelecionadas = this.storesModal.map((l) => l.instaPageName);
      }
    },
    toggleLoja(id) {
      const index = this.lojasSelecionadas.indexOf(id);
      if (index === -1) {
        this.lojasSelecionadas.push(id);
      } else {
        this.lojasSelecionadas.splice(index, 1);
      }
    },
async vincularLojas() {
  if (!this.regionalSelecionada) {
    alert("Selecione uma regional.");
    return;
  }
  if (!this.lojasSelecionadas.length) {
    alert("Selecione ao menos uma loja.");
    return;
  }

  try {
    this.isVinculando = true;
    await this.vincularLojasRegional({
      lojas: this.lojasSelecionadas, 
      regional: this.regionalSelecionada, 
    });
    this.closeModalVincular();
  } catch (error) {
    console.error(error);
    alert("Erro ao vincular lojas.");
  } finally {
    this.isVinculando = false;
  }
},

    // --- Facebook ---
    async updateTokenFacebook(data) {
      try {
        const response = await this.atualizarToken({
          fbUserId: data?.userID,
          fbUserToken: data?.accessToken,
        });

        if (response?.status === 200) {
          this.upStores = response.data;
          this.modal = true;
        }
      } catch (error) {
        console.error(error);
        alert("Houve um error ao atualizar");
      }
    },
    async logInWithFacebook() {
      const loginOptions = {
        scope: this.facebookScopes,
        return_scopes: true,
      };

      window.FB.login((response) => {
        if (response.authResponse) {
          this.updateTokenFacebook(response.authResponse);
        } else {
          alert("Usúario não existe ou não autorizado!");
        }
      }, loginOptions);
      return false;
    },
    async initFacebook() {
      window.fbAsyncInit = function () {
        if (process.env.NODE_ENV == "production") {
          window.FB.init({
            cookie: true,
            appId: "883873419293715",
            version: "v15.0",
          });
        } else {
          window.FB.init({
            appId: "855326342519443",
            cookie: true,
            version: "v14.0",
          });
        }
      };
    },
    async loadFacebookSDK(d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    },

    currentDateTime(timestamp) {
      const date = moment(timestamp).format("DD/MM/YY");
      const hour = moment(timestamp).format("HH:mm");
      return `${date} às ${hour}`;
    },

    getStoreByName: function getStoreByName(name) {
      this.nameToSearch = name;

      if (this.nameToSearch != "") {
        let objThis = this;

        clearTimeout(getStoreByName);

        setTimeout(function () {
          objThis.pagination("clickFirstPage");
        }, 500);
      } else {
        this.pagination("clickFirstPage");
      }
    },

    pagination(action) {
      const data = {
        action: action,
        offset: 0,
        name: this.nameToSearch,
        limit: 5,
      };
      switch (action) {
        case "clickFirstPage":
          this.offset = 0;
          this.SET_OFFSET(0);
          this.getInstagramRelationship(data).then((response) => {
            this.totalStores = response.data.count;
            this.stores = response.data.data;
          });
          break;
        case "clickPreviousPage": {
          this.SET_OFFSET(this.getOffset - data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getInstagramRelationship(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickNextPage": {
          this.SET_OFFSET(this.getOffset + data.limit);
          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getInstagramRelationship(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        case "clickLastPage": {
          let lastPage;
          if (this.totalStores % data.limit === 0) {
            lastPage = this.totalStores - data.limit;
          } else {
            lastPage = Math.floor(this.totalStores / data.limit) * data.limit;
          }

          this.SET_OFFSET(lastPage);

          data.offset = this.getOffset;
          this.offset = this.getOffset;

          this.getInstagramRelationship(data).then((response) => {
            this.stores = response.data.data;
          });
          break;
        }
        default:
          break;
      }
    },
    showModalFacebook() {
      this.$refs["modalFacebook"].$refs["modal-Facebook"].show();
    },
    showIsLoading(newValue) {
      this.isLoading = newValue;
    },

 async handleModalScroll() {
  const el = this.$refs.listStoreVincular;
  const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 40;

  if (nearBottom && !this.isLoadingModal && this.hasMoreModal) {
    
   console.log(this.storesModal.length, this.totalStoresModal);
    if (this.storesModal.length >= this.totalStoresModal) {
      this.hasMoreModal = false;
      return;
    }

    this.isLoadingModal = true;
    this.offsetModal += 5;

    try {
      const response = await this.getInstagramRelationship({
        action: "clickNextPage",
        offset: this.offsetModal,
        name: "",
        limit: 5,
      });

      const newData = response.data.data;

      if (newData.length === 0) {
        this.hasMoreModal = false;
      } else {
        this.storesModal = [...this.storesModal, ...newData];

        // PARA se após adicionar já atingiu o total
        if (this.storesModal.length >= this.totalStoresModal) {
          this.hasMoreModal = false;
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.isLoadingModal = false;
    }
  }
},
  },
};
</script>

<style>
#divTable {
  width: 100%;
  box-shadow: 0px 24px 38px rgba(0, 0, 0, 0.07);
  border-radius: 12px;
  padding: 24px 16px 24px 32px;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  background-color: var(--white);
  margin-bottom: 22px;
}

.input-container {
  background: #f0f2f8;
  border-radius: 8px;
  width: 310px;
  height: 42px;
  max-width: 310px;
  margin-left: 10px;
}

.modal-update {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  padding: 18px;
  justify-content: space-between;
  align-items: center;
}

.list-store {
  display: block;
  width: 70%;
  height: 188px;
  overflow: auto;
}

/* Sobrescreve o tamanho fixo do componente Modal para a modal de vincular */
.modal-vincular-wrapper .general {
  width: 600px !important;
  height: auto !important;
  min-height: 480px !important;
}

.btn-select-all {
  background: none;
  border: none;
  color: var(--primary, #0d6efd);
  font-size: 13px;
  cursor: pointer;
  padding: 0;
}

.btn-select-all:hover {
  text-decoration: underline;
}

/* Modal Vincular */
.modal-vincular {
  display: flex;
  flex-direction: column;
  padding: 32px;
  width: 100%;
  height: 100%;
  min-width: 560px;
}

.btn-close-modal {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: var(--secondary, #6c757d);
}

.list-store-vincular {
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 200px;        /* altura menor que 5 itens */
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 8px;
}

.loja-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 15px;
  transition: background 0.15s;
}

.loja-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.loja-item:hover {
  background: #f0f2f8;
}

.loja-item--selected {
  background: #eef2ff;
}

.modal-vincular .form-label {
  font-size: 15px;
  margin-bottom: 6px;
}

.modal-vincular .form-select {
  height: 48px;
  font-size: 15px;
}

.scroll-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  font-size: 13px;
  color: #6c757d;
}

.scroll-end {
  text-align: center;
  padding: 10px;
  font-size: 12px;
  color: #adb5bd;
}
</style>